// 正在加载动画
function loadingAnimation(node) {
  function listener(e) {
    const x = e.offsetX // 光标距当前层左距
    const y = e.offsetY // 光标距当前层上距
    const loadStyle = this.getElementsByClassName('load-style')[0]
    loadStyle.style.display = 'inline-block'
    loadStyle.style.left = (x - 11) + 'px'
    loadStyle.style.top = (y - 11) + 'px'
  }
  node.addEventListener('mouseenter', listener)
  node.addEventListener('mousemove', listener)
  node.addEventListener('mouseleave', function(e) {
    const loadStyle = this.getElementsByClassName('load-style')[0]
    loadStyle.style.display = 'none'
  })
}

// 获取loading
export function getLoading(className, cxt) {
  let target = null
  if (className) {
    target = document.getElementsByClassName(className)[0]
  }
  if (!target && cxt && cxt.$el) {
    target = cxt.$el
  }
  if (target) { // 局部loading
    let e = null
    const children = target.children
    if (!children) { // 元素属性异常
      return null
    }
    for (let i = children.length - 1; i >= 0; --i) {
      if (children[i].classList.contains('el-loading-mask')) {
        e = children[i]
        break
      }
    }
    if (e) {
      e.style.display = ''
    } else {
      e = document.createElement('div')
      e.className = 'el-loading-mask'
      e.style.cursor = 'none'
      e.style.background = 'transparent'
      e.innerHTML = '<span class="load-style"></span>'
      loadingAnimation(e)
      target.appendChild(e)
    }
    return {
      close: () => {
        // 等当前操作处理完后，再执行
        setTimeout(() => {
          e.style.display = 'none'
        })
      }
    }
  } else { // 全局loading
    let e = document.getElementById('global-loading')
    if (e) {
      e.style.display = ''
    } else {
      e = document.createElement('div')
      e.id = 'global-loading'
      e.className = 'el-loading-mask is-fullscreen'
      e.style.cursor = 'none'
      e.style.background = 'transparent'
      e.style.zIndex = '2001'
      e.innerHTML = '<span class="load-style"></span>'
      loadingAnimation(e)
      document.body.appendChild(e)
    }
    return {
      close: () => {
        // 等当前操作处理完后，再执行
        setTimeout(() => {
          e.style.display = 'none'
        })
      }
    }
  }
}

// 获取loading（根据vue上下文）
export function getLoading4Cxt(cxt) {
  return getLoading('', cxt)
}
